import React, { useEffect, useState } from 'react';
import { Grid, InputLabel, FormControl, TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, useMediaQuery, FormHelperText, Typography, Checkbox } from '@mui/material';

import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchItemMaterialData } from '../../../Store/PHPSlice/Item';
import { selectItemMaterialData } from '../../Selectors/Master/ItemSelectors';


const MaterialView = () => {
    const { Id } = useParams();
    const [material, setMaterial] = useState([]);
    const dispatch = useDispatch();
    const materialData = useSelector(selectItemMaterialData);
    useEffect(() => {
        dispatch(fetchItemMaterialData(Id));
    }, [dispatch, Id]);

    useEffect(() => {
        if (materialData?.data?.length > 0) {
            const data = materialData?.data;
            setMaterial(data);
        }
    }, [materialData]);

    return (
        <>

            <div style={{ margin: '1% 0.5%' }}>
                <h2>Material View</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>

                            <div className="lump-content">
                                {/* <h3>Material View</h3> */}
                                {/* <div className="button-group">
                                        <button className="add" onClick={handleAddlump}>Add</button>
                                        <button className="delete" onClick={handleRemoveLumps}>Remove</button>
                                    </div> */}
                                <table style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Material</th>
                                            <th>Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {material.map((mat, matIndex) => (
                                            <>
                                                <tr key={matIndex}>
                                                    <td>
                                                        {matIndex + 1}
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            placeholder="material name"
                                                            value={mat.materialNm}
                                                            readOnly
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            placeholder="qty"
                                                            value={mat.qty}
                                                            readOnly
                                                        />
                                                    </td>


                                                </tr>
                                            </>
                                        ))}
                                        {/* <tr>
                                                <td> </td>
                                                <td> </td>
                                                <td>
                                                    <span className="tot-lump">Total Lump Mtr</span>
                                                </td>
                                                <td>
                                                    <span className="tot-lump">{lumpTotMtr}</span>
                                                </td>
                                            </tr> */}
                                    </tbody>
                                </table>

                            </div>


                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default MaterialView;
